export const initData = {
    nowList: "productList",
    productList: [],
    foodList: [],
    productCoupons: [],
    foodCoupons: [],
    selectedProductCouponId: -1,
    selectedFoodCouponId: -1,
    total: 0,
    lastInsertId: -1,
    foodCount: [],
    frontpagecoupon: true,
};
